import React from 'react';
import PropTypes from 'prop-types';
import TextInput from '../../../core/form/TextInput';

const VocabularyThemeListFilter = (props) => (
  <TextInput
    label="Search vocabulary themes"
    placeholder="Start type to filter the vocabulary themes"
    value={props.value}
    onChange={props.onChange}
  />
);

VocabularyThemeListFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default VocabularyThemeListFilter;
